import { DashboardRouteNames, automationRouteNames, blogsRouteNames, calendarRouteNames, contactsRouteNames, conversationRouteNames, locationSettingsRouteNames, opportunitiesRouteNames, reportingRouteNames } from '@/routes/constants/location'
const routesRequiredPermissions = {
  template_settings: 'settings_enabled',
  company_settings: 'settings_enabled',
  location_team_management: 'settings_enabled',
  location_teams_management: 'settings_enabled',
  email_settings: 'settings_enabled',
  chat_widget_settings: 'settings_enabled',
  chat_widget: 'settings_enabled',
  edit_chat_widget: 'settings_enabled',
  chat_widget_builder: 'settings_enabled',
  sms_settings: 'settings_enabled',
  customize_communications: 'settings_enabled',
  review_widgets: 'settings_enabled',
  appointment_widget: 'settings_enabled',
  pipeline_settings: 'settings_enabled',
  payment_settings: 'settings_enabled',
  phone_number: 'settings_enabled',
  custom_fields_settings: 'settings_enabled',
  facebook_settings: 'settings_enabled',
  custom_values_settings: 'settings_enabled',
  conversations: 'conversations_enabled',
  triggers: 'triggers_enabled',
  triggers_detail: 'triggers_enabled',
  customer_acquisition: 'campaigns_enabled',
  campaign_edit: 'campaigns_enabled',
  campaign_detail: ['campaigns_enabled', 'campaigns_read_only'],
  campaign_accounts_list: 'campaigns_enabled',
  campaign_activity: 'campaigns_enabled',
  workflows: ['workflows_enabled', 'workflows_read_only'],
  newWorkflow: 'workflows_enabled',
  editWorkflow: ['workflows_enabled', 'workflows_read_only'],
  bulk_requests: 'bulk_requests_enabled',
  opportunities_bulk_actions: 'opportunities_bulk_actions_enabled',
  email_builder_dashboard: 'marketing_enabled',
  email_builder_list: 'marketing_enabled',
  text_templates: 'marketing_enabled',
  form_builder_manage: 'marketing_enabled',
  form_builder_integrate: 'marketing_enabled',
  jotbox_form: 'marketing_enabled',
  jotbox_survey: 'marketing_enabled',
  appointments: 'appointments_enabled',
  'calendar-v2': 'appointments_enabled',
  'reputation-overview-v2': 'reviews_enabled',
  'reputation-review-requests-v2': 'reviews_enabled',
  'reputation-reviews-v2': 'reviews_enabled',
  'reputation-widget-v2': 'reviews_enabled',
  'reputation-listing-v2': 'online_listings_enabled',
  'reputation-gbp-v2': 'online_listings_enabled',
  'reputation-settings-v2': ['settings_enabled', 'reviews_enabled'],
  customers: 'contacts_enabled',
  leads: 'contacts_enabled',
  contact_detail: 'contacts_enabled',
  contacts: 'contacts_enabled',
  manual_actions: 'contacts_enabled',
  smart_list: 'contacts_enabled',
  customer_imports: 'contacts_enabled',
  phone_calls: 'phone_call_enabled',
  opportunities: 'opportunities_enabled',
  pipeline: 'opportunities_enabled',
  funnel_main: 'funnels_enabled',
  all_funnels: 'funnels_enabled',
  fav_funnels: 'funnels_enabled',
  recent_funnels: 'funnels_enabled',
  archived_funnels: 'funnels_enabled',
  funnels_detail: 'funnels_enabled',
  funnel_steps: 'funnels_enabled',
  funnel_step_overview: 'funnels_enabled',
  funnel_step_automation: 'funnels_enabled',
  funnel_step_publish: 'funnels_enabled',
  funnel_step_product: 'funnels_enabled',
  funnel_stats: 'funnels_enabled',
  funnel_sales: 'funnels_enabled',
  funnel_settings: 'funnels_enabled',
  funnel_templates_category: 'funnels_enabled',
  websites_funnels: 'websites_enabled',
  stores_funnels: 'websites_enabled',
  webinars_funnels: 'websites_enabled',
  websites_detail: 'websites_enabled',
  website_pages: 'websites_enabled',
  website_stats: 'websites_enabled',
  website_settings: 'websites_enabled',
  website_templates_category: 'websites_enabled',
  website_templates_category_detail: 'websites_enabled',
  website_templates_detail: 'websites_enabled',
  stores_detail: 'websites_enabled',
  store_pages: 'websites_enabled',
  store_stats: 'websites_enabled',
  store_product_select: 'websites_enabled',
  store_settings: 'websites_enabled',
  store_templates_category: 'websites_enabled',
  store_templates_category_detail: 'websites_enabled',
  store_templates_detail: 'websites_enabled',
  webinar_detail: 'websites_enabled',
  webinar_pages: 'websites_enabled',
  webinar_stats: 'websites_enabled',
  webinar_settings: 'websites_enabled',
  webinar_templates_category: 'websites_enabled',
  webinar_templates_category_detail: 'websites_enabled',
  webinar_templates_detail: 'websites_enabled',
  tag: 'tags_enabled',
  smtp_service: 'settings_enabled',
  membership: 'membership_enabled',
  'form-builder-v2': 'forms_enabled',
  'form-builder-main-v2': 'forms_enabled',
  'form-builder-analyze-v2': 'forms_enabled',
  'form-builder-submissions-v2': 'forms_enabled',
  'form-builder-manage': 'forms_enabled',
  'quiz-builder-v2': 'quizzes_enabled',
  'quiz-builder-main': 'quizzes_enabled',
  'quiz-builder-submissions': 'quizzes_enabled',
  'jotbox_form-v2': 'surveys_enabled',
  'survey-builder-v2': 'surveys_enabled',
  'survey-builder-main-v2': 'surveys_enabled',
  'survey-builder-analyze-v2': 'surveys_enabled',
  'survey-builder-submissions-v2': 'surveys_enabled',
  'chat-widget-settings-v2': 'settings_enabled',
  'calendar-settings-v2': 'settings_enabled',
  'automation-settings-v2': 'settings_enabled',
  [locationSettingsRouteNames.smartList]: 'settings_enabled',
  [locationSettingsRouteNames.pipeline]: 'settings_enabled',
  [opportunitiesRouteNames.pipeline]: 'opportunities_enabled',
  [locationSettingsRouteNames.company]: 'settings_enabled',
  [locationSettingsRouteNames.locationBilling.billingV2]: 'settings_enabled',
  [locationSettingsRouteNames.staff.team]: 'settings_enabled',
  [locationSettingsRouteNames.staff.teams]: 'settings_enabled',
  'crm-settings': 'settings_enabled',
  [locationSettingsRouteNames.staff.default]: 'settings_enabled',
  'eliza-faq-v2': 'settings_enabled',
  [locationSettingsRouteNames.phoneNumber]: 'settings_enabled',
  'custom-fields-v2': 'settings_enabled',
  [locationSettingsRouteNames.fields]: 'settings_enabled',
  [locationSettingsRouteNames.customEmails]: 'settings_enabled',
  [locationSettingsRouteNames.tags]: 'tags_enabled',
  [locationSettingsRouteNames.customValues]: 'settings_enabled',
  [locationSettingsRouteNames.domain]: 'settings_enabled',
  [locationSettingsRouteNames.scoring]: 'settings_enabled',
  [locationSettingsRouteNames.emailService.default]: 'settings_enabled',
  'settings-v2': 'settings_enabled',
  'product-list-v2': 'settings_enabled',
  'transactions-v2': 'settings_enabled',
  'payment-integrations-v2': 'payments_enabled',
  'payments-v2': 'payments_enabled',
  'triggers-links-link-v2': 'trigger_links_enabled',
  'triggers-links-analyze-v2': 'trigger_links_enabled',
  [automationRouteNames.triggerDetail]: 'triggers_enabled',
  [automationRouteNames.workflows]: ['workflows_enabled', 'workflows_read_only'],
  [automationRouteNames.newWorkflows]: 'workflows_enabled',
  [automationRouteNames.campaignEdit]: ['campaigns_enabled', 'campaigns_read_only'],
  [automationRouteNames.campaigns]: ['campaigns_enabled', 'campaigns_read_only'],
  [opportunitiesRouteNames.list]: 'opportunities_enabled',
  [opportunitiesRouteNames.default]: 'opportunities_enabled',
  [conversationRouteNames.conversationsIdV2]: 'conversations_enabled',
  [conversationRouteNames.manualActions]: 'contacts_enabled',
  [conversationRouteNames.conversationsV2]: 'conversations_enabled',
  [contactsRouteNames.smartList]: 'contacts_enabled',
  [contactsRouteNames.contactDetail]: 'contacts_enabled',
  'bulk-imports-log-v2': 'contacts_enabled',
  [contactsRouteNames.bulkActions]: 'contacts_enabled',
  [contactsRouteNames.contactRestore]: 'contacts_enabled',
  'contacts-contacts-v2': 'contacts_enabled',
  'leads-v2': 'contacts_enabled',
  [contactsRouteNames.default]: 'contacts_enabled',
  [calendarRouteNames.default]: 'appointments_enabled',
  [calendarRouteNames.calendarPageV2]: 'appointments_enabled',
  'appointments-v2': 'appointments_enabled',
  [reportingRouteNames.callStats]: 'phone_call_enabled',
  'funnels-v2': 'funnels_enabled',
  'funnels-page-v2': 'funnels_enabled',
  'fav_funnels-v2': 'funnels_enabled',
  'recent_funnels-v2': 'funnels_enabled',
  'archived_funnels-v2': 'funnels_enabled',
  'funnels-detail-v2': 'funnels_enabled',
  'funnel-steps-v2': 'funnels_enabled',
  'funnel-step-overview-v2': 'funnels_enabled',
  'funnel-step-automation-v2': 'funnels_enabled',
  'funnel-step-publish-v2': 'funnels_enabled',
  'funnel-step-product-v2': 'funnels_enabled',
  'funnel-step-products-v2': 'funnels_enabled',
  'funnel-step-product-v2-create': 'funnels_enabled',
  'funnel-step-product-v2-edit': 'funnels_enabled',
  'funnel-stats-v2': 'funnels_enabled',
  'funnel-sales-v2': 'funnels_enabled',
  'funnel-settings-v2': 'funnels_enabled',
  'funnel-security-v2': 'funnels_enabled',
  'funnel-events-v2': 'funnels_enabled',
  'funnel-templates-category': 'funnels_enabled',
  'funnel-templates-category-detail': 'funnels_enabled',
  'funnel-templates-detail': 'funnels_enabled',
  'websites-funnels-v2': 'websites_enabled',
  'stores-funnels-v2': 'websites_enabled',
  'webinars-funnels-v2': 'websites_enabled',
  'websites-detail-v2': 'websites_enabled',
  'webinars-detail-v2': 'websites_enabled',
  'website-pages-v2': 'websites_enabled',
  'website-stats-v2': 'websites_enabled',
  'website-sales-v2': 'websites_enabled',
  'website-settings-v2': 'websites_enabled',
  'website-security-v2': 'website_enabled',
  'website-events-v2': 'website_enabled',
  'website-products-v2': 'websites_enabled',
  'website-step-products-v2': 'websites_enabled',
  'website-templates-category': 'websites_enabled',
  'website-templates-category-detail': 'websites_enabled',
  'website-templates-detail': 'websites_enabled',
  'store-detail-v2': 'websites_enabled',
  'store-pages-v2': 'websites_enabled',
  'store-stats-v2': 'websites_enabled',
  'store-product-select-v2': 'websites_enabled',
  'store-sales-v2': 'websites_enabled',
  'store-settings-v2': 'websites_enabled',
  'store-security-v2': 'website_enabled',
  'store-events-v2': 'website_enabled',
  'store-products-v2': 'websites_enabled',
  'store-step-products-v2': 'websites_enabled',
  'store-templates-category': 'websites_enabled',
  'store-templates-category-detail': 'websites_enabled',
  'store-templates-detail': 'websites_enabled',
  'webinar-pages-v2': 'websites_enabled',
  'webinar-stats-v2': 'websites_enabled',
  'webinar-sales-v2': 'websites_enabled',
  'webinar-settings-v2': 'websites_enabled',
  'webinar-security-v2': 'website_enabled',
  'webinar-events-v2': 'website_enabled',
  'webinar-products-v2': 'websites_enabled',
  'webinar-step-products-v2': 'websites_enabled',
  'webinar-templates-category': 'websites_enabled',
  'webinar-templates-category-detail': 'websites_enabled',
  'webinar-templates-detail': 'websites_enabled',
  'emails_home-v2': 'marketing_enabled',
  'social-planner-v2': 'social_planner',
  'social-planner-dashboard-v2': 'social_planner',
  'social-planner-content': 'social_planner',
  'social-planner-planner': 'social_planner',
  'social-planner-statistics': 'social_planner',
  'payment-products-list-invoices': 'invoice_enabled',
  'invoice-settings': 'invoice_enabled',
  'payment-products-list-recurring-invoices': 'invoice_enabled',
  'emails_home-detail-v2': 'marketing_enabled',
  'brand-boards': 'marketing_enabled',
  'brand-boards-builder': 'marketing_enabled',
  'brand-voice-builder': 'marketing_enabled',
  'default-emails': 'settings_enabled',
  'marketing-v2': 'marketing_enabled',
  'templates-v2': 'marketing_enabled',
  [conversationRouteNames.templates]: 'marketing_enabled',
  'email_builder_dashboard-v2': 'marketing_enabled',
  'email_builder_list-v2': 'marketing_enabled',
  [blogsRouteNames.default]: 'blogging_enabled',
  'affiliate-manager-campaign-page-v2': 'affiliate_manager_enabled', //affiliate manager,
  'affiliate-manager-dashboard-page-v2': 'affiliate_manager_enabled',
  'payments-products-v2': 'payments_enabled',
  'payments-products-v1': 'payments_enabled',
  'taxes-v2': 'payments_enabled',
  'orders-v2-new': 'payments_enabled',
  abandoned_checkouts: 'payments_enabled',
  'subscriptions-v2': 'payments_enabled',
  'transactions-v2-new': 'payments_enabled',
  coupons: 'payments_enabled',
  'proposals-estimates': 'payments_enabled',
  'proposals-estimates-edit': 'proposals_enabled',
  'invoice-templates': 'invoice_enabled',
  'membership-product-comments': 'membership_enabled',
  [DashboardRouteNames.custom]: 'reporting_enabled',
  'qr-codes': 'qr_codes_enabled',
  [DashboardRouteNames.reportCreate]: 'reporting_enabled',
  [DashboardRouteNames.reportBuilder]: 'reporting_enabled',
  [DashboardRouteNames.reportSchedule]: 'reporting_enabled',
  'countdown-timer-list-v2': 'marketing_enabled',
  'calendar-settings__default': 'appointments_enabled',
  'calendar-settings__preferences': 'appointments_enabled',
  'calendar-settings__availability': 'appointments_enabled',
  'calendar-settings__connections': 'appointments_enabled',
}

const locationLevelRoutesPermissions = {
  dashboard: 'dashboard_stats_enabled',
  [DashboardRouteNames.default]: 'dashboard_stats_enabled',
  email_builder_dashboard: 'html_builder_enabled',
  email_builder_list: 'html_builder_enabled',
  text_templates: 'sms_email_templates_enabled',
  'templates-v2': 'sms_email_templates_enabled',
  [conversationRouteNames.templates]: 'sms_email_templates_enabled',
  form_builder: 'forms_enabled',
  form_builder_manage: 'forms_enabled',
  form_builder_integrate: 'forms_enabled',
  template_settings: 'sms_email_templates_enabled',
  appointment_widget: 'appointments_enabled',
  location_team_management: 'appointments_enabled',
  location_teams_management: 'appointments_enabled',
  calendar_settings: 'appointments_enabled',
  'calendars-v2': 'appointments_enabled',
  [calendarRouteNames.default]: 'appointments_enabled',
  [calendarRouteNames.calendarPageV2]: 'appointments_enabled',
  domain_settings: ['funnels_enabled', 'websites_enabled'], // show domains for anyone of the permissions,
  'funnels-page-v2': 'funnels_enabled',
  'websites-funnels-v2': 'websites_enabled',
  'stores-funnels-v2': 'websites_enabled',
  'webinars-funnels-v2': 'websites_enabled',
  emails_home: 'email_builder_enabled',
  list_survey: 'surveys_enabled',
  survey_manage: 'surveys_enabled',
  survey_integrate: 'surveys_enabled',
  reporting_adwords: 'adwords_reporting_enabled',
  reporting_facebook: 'facebook_ads_reporting_enabled',
  reporting_attribution: 'attributions_reporting_enabled',
  'appointments-reports': 'appointments_enabled',
  [reportingRouteNames.appointments]: 'appointments_enabled',
  call_stats: 'phone_call_enabled',
  agent_reporting: 'agent_reporting_enabled',
  gmb: 'gmb_messaging_enabled',
  'emails_home-v2': 'email_builder_enabled',
  'emails_home-detail-v2': 'email_builder_enabled',
  'marketing-v2': 'email_builder_enabled',
  'reporting-adwords-campaigns-v2': 'adwords_reporting_enabled',
  'reporting-adwords-adgroups-v2': 'adwords_reporting_enabled',
  'reporting-adwords-ads-v2': 'adwords_reporting_enabled',
  'reporting-adwords-keywords-v2': 'adwords_reporting_enabled',
  'reporting-adwords-conversions-v2': 'adwords_reporting_enabled',
  [reportingRouteNames.google]: 'adwords_reporting_enabled',
  'reporting-facebook-campaigns-v2': 'facebook_ads_reporting_enabled',
  'reporting-facebook-adsets-v2': 'facebook_ads_reporting_enabled',
  'reporting-facebook-ads-v2': 'facebook_ads_reporting_enabled',
  'reporting-facebook-demographics-v2': 'facebook_ads_reporting_enabled',
  [reportingRouteNames.facebook]: 'facebook_ads_reporting_enabled',
  'reporting-attribution-v2': 'attributions_reporting_enabled',
  [reportingRouteNames.callStats]: 'phone_call_enabled',
  [reportingRouteNames.agent]: 'agent_reporting_enabled',
  'email_builder_dashboard-v2': 'html_builder_enabled',
  'email_builder_list-v2': 'html_builder_enabled',
  'social-planner-v2': 'social_planner',
  'social-planner-dashboard-v2': 'social_planner',
  'payment-products-list-invoices': 'invoice_enabled',
  'blogging': 'blogging_enabled',
  'communities': 'communities_enabled',
  'certificates': 'certificates_enabled',
  'media-storage': 'media_storage_enabled',
  'proposals-estimates': 'proposals_enabled',
  'proposals-estimates-edit': 'proposals_enabled',
  'membership-product-comments': 'membership_enabled',
  'qr_codes':"qr_codes_enabled",
  workflows: 'workflows_enabled',
  newWorkflow: 'workflows_enabled',
  editWorkflow: 'workflows_enabled',
}

const paymentBetaAccessRoutes = ['product-list', 'transactions']

export { locationLevelRoutesPermissions, paymentBetaAccessRoutes, routesRequiredPermissions }
